import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import RequiredSecureAuth from '@components/SecureRoute/SecureRoute';
import CustomLoginCallback from "@/components/CustomLoginCallback/CustomLoginCallback"; 

import CanvasLandingMilestone from '@/pages/CanvasLandingMilestone/CanvasLandingMilestone';
import LearningCoachDashboard from '@/pages/LearningCoachDashboard/LearningCoachDashboard';
import TeacherCoachDashboard from '@/pages/TeacherCoachDashboard/TeacherCoachDashboard';
import Overview from '@/pages/Overview/Overview';
import SchoolInformation from '@/pages/SchoolInformation/SchoolInformation';
import SchoolPrepChecklist from '@/pages/SchoolPrepChecklist/SchoolPrepChecklist';
import Support from '@/pages/Support/Support';
import LearningCenterPage from '@/pages/LearningCenterPage/LearningCenterPage';
import ClassroomMaterialsPage from '@/pages/ClassroomMaterialsPage/ClassroomMaterialsPage';

import NotFound from '@/pages/NotFoundScreen/NotFoundScreen';
import MainLayout from '../layout/MainLayout/MainLayout';
import ErrorScreen from '@/pages/ErrorScreen/ErrorScreen';

import SchoolDocuments from '@pages/checklist/SchoolDocuments';
import LearningMaterials from '@pages/checklist/LearningMaterials';
import StudentAccountSetUp from '@pages/checklist/StudentAccountSetUp';
import TasklistJsonPage from '@pages/checklist/TasklistJsonPage';
import AboutAttendingSchool from '@/pages/school-information/AboutAttendingSchool';
import NavigatingK12School from '@/pages/school-information/NavigatingK12School';
import BeingLearningCoach from '@/pages/school-information/BeingLearningCoach';
import SchoolStartFAQs from '@/pages/school-information/SchoolStartFAQs';
import { HERO_TASK_PAGE_REDIRECT_LOOKUP, taskHeroPagePath } from '@/utils/tasklistPath';

/** Legacy `/checklist/page/:pageId` → `/task/page/{slug}` when known (else same segment). */
const LegacyChecklistPageRedirect = () => {
  const { pageId } = useParams();
  if (!pageId) return <Navigate to="/tasklist" replace />;
  return <Navigate to={taskHeroPagePath(pageId, HERO_TASK_PAGE_REDIRECT_LOOKUP)} replace />;
};

const AppRoutes = () => {
return (
    <Routes>
        {/* Protected Routes */}
        <Route path="/" element={<RequiredSecureAuth />}>
            <Route element={<MainLayout />}>
                <Route path="overview" element={<Overview />} />
                <Route path="tasklist" element={<SchoolPrepChecklist />} />
                <Route path="checklist" element={<Navigate to="/tasklist" replace />} />
                <Route path="schoolinfo" element={<SchoolInformation />} />
                <Route path="help-and-support" element={<Support />} />
                <Route path="support" element={<Navigate to="/help-and-support" replace />} />
                <Route path="task/page/:pageId" element={<TasklistJsonPage />} />
                <Route path="tasklist/page/:pageId" element={<TasklistJsonPage />} />
                <Route path="checklist/page/:pageId" element={<LegacyChecklistPageRedirect />} />
                <Route path="tasklist/school-documents" element={<SchoolDocuments />} />
                <Route path="checklist/school-documents" element={<Navigate to="/tasklist/school-documents" replace />} />
                <Route path="tasklist/learning-materials" element={<LearningMaterials />} />
                <Route path="checklist/learning-materials" element={<Navigate to="/tasklist/learning-materials" replace />} />
                <Route path="tasklist/student-account-set-up" element={<StudentAccountSetUp />} />
                <Route path="checklist/student-account-set-up" element={<Navigate to="/tasklist/student-account-set-up" replace />} />
                <Route path="tasklist/setup-and-access" element={<StudentAccountSetUp />} />
                <Route path="checklist/setup-and-access" element={<Navigate to="/tasklist/setup-and-access" replace />} />
                <Route path="schoolinfo/about-attending-school" element={<AboutAttendingSchool />} />
                <Route path="schoolinfo/navigating-k12-school" element={<NavigatingK12School />} />
				<Route path="schoolinfo/school-start-faqs" element={<SchoolStartFAQs />} />
                <Route path="schoolinfo/being-learning-coach" element={<BeingLearningCoach />} />
                <Route path="learning-center" element={<LearningCenterPage />} />
                <Route path="classroom-materials-tracker" element={<ClassroomMaterialsPage />} />
                <Route path="classroom-materials" element={<Navigate to="/classroom-materials-tracker" replace />} />
            </Route>
            <Route path="learning-coach" element={<LearningCoachDashboard />} />
            <Route path="school-selection" element={<TeacherCoachDashboard />} />
            <Route path="milestone-1" element={<CanvasLandingMilestone />} />
        </Route>

        {/* Error and fallback routes */}
        <Route path="error" element={<ErrorScreen />} />
        {/* Okta Callback Route */}
        <Route path="/login/callback" element={<CustomLoginCallback />} />
        {/* Catch-all Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
);
};
export default AppRoutes;
